import { DashboardStats, Reservation } from '../types';
import apiService from './api';

export class DashboardService {
  async getDashboardStats(): Promise<DashboardStats> {
    return apiService.get<DashboardStats>('/api/dashboard/admin-stats');
  }

  async getRecentReservations(): Promise<Reservation[]> {
    return apiService.get<Reservation[]>('/api/dashboard/recent-operations');
  }

  async getSystemHealth(): Promise<any> {
    return apiService.get('/api/dashboard/health');
  }

  async getAnalytics(period: string = '7d'): Promise<any> {
    return apiService.get('/api/dashboard/analytics', { period });
  }
}

export const dashboardService = new DashboardService();
export default dashboardService;
